import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import {
    UserOutlined,
    LockOutlined,
    RocketOutlined,
    CloudServerOutlined,
    SafetyCertificateOutlined,
    AppstoreOutlined,
    PieChartOutlined,
    DeploymentUnitOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../utils/request';
import './Login.css';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await request.post('/admin/login', {
                username: values.username,
                password: values.password,
            });

            if (res.code === 0) {
                message.success('登录成功');
                localStorage.setItem('user_token', res.data.user_token);
                localStorage.setItem('user_info', JSON.stringify(res.data.user_info));
                localStorage.setItem('user_codes', JSON.stringify(res.data.codes || []));
                localStorage.setItem('user_hidden_fields', JSON.stringify(res.data.hidden_fields || {}));
                navigate('/');
            } else {
                message.error(res.message || '登录失败');
            }
        } catch (error) {
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            {/* 左侧品牌区域 */}
            <div className="login-left">
                <div className="login-left-content">
                    <div className="login-logo-top">
                        <div className="logo-icon-small">ELF</div>
                        <span className="logo-text-small">易莱孚生产管理后台</span>
                    </div>

                    <div className="hero-section">
                        <h1 className="hero-title">
                            为企业打造<br />
                            <span className="highlight">一站式管理平台</span>
                        </h1>
                        <p className="hero-subtitle">高效、安全、可扩展的后台管理系统</p>
                    </div>

                    <div className="feature-grid">
                        <div className="feature-card">
                            <div className="feature-icon-box"><DeploymentUnitOutlined /></div>
                            <div className="feature-info">
                                <h3>模块化管理</h3>
                                <p>按业务模块组织页面，清晰可维护</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><CloudServerOutlined /></div>
                            <div className="feature-info">
                                <h3>无缝集成</h3>
                                <p>与后端服务轻松对接</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><SafetyCertificateOutlined /></div>
                            <div className="feature-info">
                                <h3>安全可靠</h3>
                                <p>基于 Token 的鉴权机制</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><AppstoreOutlined /></div>
                            <div className="feature-info">
                                <h3>组件丰富</h3>
                                <p>基于 Ant Design 的丰富组件</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><PieChartOutlined /></div>
                            <div className="feature-info">
                                <h3>数据可视化</h3>
                                <p>集成 ECharts 图表能力</p>
                            </div>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon-box"><RocketOutlined /></div>
                            <div className="feature-info">
                                <h3>快速迭代</h3>
                                <p>模板化开发，快速交付</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 右侧登录表单 */}
            <div className="login-right">
                <div className="login-card-wrapper">
                    <div className="login-card">
                        <h1 className="login-welcome-title">欢迎回来！</h1>

                        <div className="login-tabs">
                            <span className="login-tab-item active">账号登录</span>
                        </div>

                        <Form
                            name="login_form"
                            className="login-form-body"
                            initialValues={{ remember: true }}
                            onFinish={onFinish}
                        >
                            <Form.Item
                                name="username"
                                rules={[{ required: true, message: '请输入账户名!' }]}
                            >
                                <Input
                                    prefix={<UserOutlined className="input-icon" />}
                                    placeholder="账号"
                                    size="large"
                                    className="login-input-themed"
                                />
                            </Form.Item>

                            <Form.Item
                                name="password"
                                rules={[{ required: true, message: '请输入密码!' }]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined className="input-icon" />}
                                    placeholder="密码"
                                    size="large"
                                    className="login-input-themed"
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-submit-btn" loading={loading} size="large">
                                    登录
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
